import { InputBase } from "components/Atoms/formInputs/InputBase";
import React from "react";

interface Props {
  value: string
  error: boolean | string
  onChange: (value: string) => void
  onBlur: () => void
  innerRef: React.Ref<HTMLInputElement>
  isLoading: boolean
}

const PasswordInputBase = (props: Props) => {
  const hasErrors = !!props.error;
  return <>
    <InputBase
      ref={props.innerRef}
      type="password"
      value={props.value}
      error={hasErrors}
      onChange={value => { props.onChange(value); }}
      onBlur={props.onBlur}
      loading={props.isLoading}
    />
    {typeof props.error === "string" && props.error.split("\n").map(v => (
      <div key={v} className="s1_red">
        {v}
      </div>
    ))}
  </>;
};

export default PasswordInputBase;